import React, { ReactChild } from 'react';
import dayjs from 'dayjs';
import { iReportProPublication } from "@models/ReportProPublication";
import { FCX } from "@datassential/platform-ui-lib";

const TileSubTitle: FCX<{
    data: iReportProPublication;
    uppercase?: boolean;
}> = (
    {
        data,
        uppercase,
        testId,
    }
) => {
    const { createdDate, numberOfPages, minutesToRead } = data;
    const spans: ReactChild[] = [];

    if (createdDate) {
        spans.push((
            <>{dayjs(createdDate).format('MMMM YYYY')}</>
        ));
    }
    if (numberOfPages) {
        spans.push((
            <>{numberOfPages} pages</>
        ));
    }
    if (minutesToRead) {
        spans.push((
            <>{minutesToRead} min read</>
        ));
    }
    return (
        <div
            className="ReportProTile__sub-title"
            data-testid={testId}
        >
            {spans.map((span, index) => (
                <div key={index} style={{ textTransform: uppercase ? 'uppercase' : 'none' }}>
                    {span}
                    {index < spans.length - 1 && <>&nbsp;·&nbsp;</>}
                </div>
            ))}
        </div>
    );
};

export default TileSubTitle;
